module.exports = __webpack_public_path__ + "f3451edfb32a410551c53ed77f48ed88.png";